export default "__VITE_ASSET__Chpl6xnj__"